import { ShaffofId, type ShaffofIdOptions } from './index'
import { LABELS, SHAFFOF_LOGO_SVG, type Locale } from './logo'

export type ButtonOptions = ShaffofIdOptions & {
  locale?: Locale
  variant?: 'primary' | 'outline' | 'dark'
  size?: 'sm' | 'md' | 'lg'
  fullWidth?: boolean
  /** Bosilganda o'zingiz boshqarmoqchi bo'lsangiz */
  onClick?: (client: ShaffofId) => void
}

/**
 * Oddiy HTML sahifaga «Shaffof ID orqali kirish» tugmasini qo'yadi.
 *
 *   createShaffofIdButton('#login', {
 *     issuer: 'https://id.shaffof.uz',
 *     clientId: '...',
 *     redirectUri: 'https://example.uz/callback',
 *   })
 */
export function createShaffofIdButton(
  target: string | HTMLElement,
  options: ButtonOptions,
): { element: HTMLButtonElement; client: ShaffofId } {
  const container = typeof target === 'string' ? document.querySelector(target) : target

  if (!container) {
    throw new Error(`Shaffof ID: «${String(target)}» elementi topilmadi.`)
  }

  const client = new ShaffofId(options)
  const locale = options.locale ?? 'uz'

  const button = document.createElement('button')
  button.type = 'button'
  button.className = [
    'shaffof-id-btn',
    `shaffof-id-btn--${options.variant ?? 'primary'}`,
    `shaffof-id-btn--${options.size ?? 'md'}`,
    options.fullWidth ? 'shaffof-id-btn--block' : '',
  ].filter(Boolean).join(' ')

  button.innerHTML = `${SHAFFOF_LOGO_SVG}<span>${LABELS[locale]}</span>`

  button.addEventListener('click', () => {
    if (options.onClick) {
      options.onClick(client)
      return
    }

    button.classList.add('shaffof-id-btn--loading')
    button.disabled = true

    void client.login().catch((error: unknown) => {
      button.classList.remove('shaffof-id-btn--loading')
      button.disabled = false
      console.error('Shaffof ID:', error)
    })
  })

  container.appendChild(button)

  return { element: button, client }
}
